import React, { useContext, useMemo } from 'react'
import { useGoTemplates } from '../go-templates-context'
import { useExperimentService, useUserService, useBrowserService } from '../../../../lib/hooks'
import { ParaphrasingDesktopFooter } from './ParaphrasingDesktopBanner'
import { PageContext } from '../../../../contexts/page-context'

import '@grammarly/design-system/dist/index.css'

export const FooterBanner: React.FC = () => {
  const { slug } = useContext(PageContext)
  const { isMobileOrTablet } = useBrowserService()
  const { isAnonymous } = useUserService().currentUser
  const { gnarTrackFn, sideBySideClicked } = useGoTemplates()

  const { isDynamicBannerV2 } = useExperimentService()

  const isDynamicBannerTreatment = useMemo(
    () => isDynamicBannerV2(slug, isMobileOrTablet, isAnonymous),
    [slug, isMobileOrTablet, isAnonymous, isDynamicBannerV2]
  )

  return (
    <ParaphrasingDesktopFooter
      sideBySideClicked={sideBySideClicked}
      isDynamicBannerTreatment={isDynamicBannerTreatment}
      gnarTrackFn={gnarTrackFn}
    />
  )
}
